import { axios } from 'utils/network/axios';

class SegmentTargetService {
  list(body) {
    return axios.post('/segment-target/list', body);
  }
}

export default new SegmentTargetService();
